import React, { useState } from "react"
import { Modal } from "react-bootstrap"
import { FaQuestion } from "react-icons/fa"

import guides from "../../help/guides"
import classes from "./index.module.scss"

const ContextHelp = ({ guide, className = "" }) => {
  const [open, setOpen] = useState(false)
  const content = guides[guide]

  if (!content) return null

  return (
    <>
      <button
        type="button"
        className={`${classes["help-button"]} ${className}`}
        aria-label={`راهنمای ${content.title}`}
        title="راهنمای این بخش"
        onClick={event => {
          event.stopPropagation()
          setOpen(true)
        }}
      >
        <FaQuestion size={12} />
      </button>

      <Modal
        show={open}
        onHide={() => setOpen(false)}
        size="lg"
        centered
        scrollable
      >
        <Modal.Header closeButton>
          <Modal.Title>{content.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body className={classes["body"]}>
          <p className={classes["intro"]}>{content.intro}</p>
          {content.sections.map(section => (
            <section key={section.title} className={classes["section"]}>
              <h3>{section.title}</h3>
              {section.body && <p>{section.body}</p>}
              {section.steps &&
                <ol>{section.steps.map(item => <li key={item}>{item}</li>)}</ol>
              }
              {section.bullets &&
                <ul>{section.bullets.map(item => <li key={item}>{item}</li>)}</ul>
              }
              {section.example &&
                <div className={classes["example"]}>
                  <strong>مثال: </strong>{section.example}
                </div>
              }
            </section>
          ))}
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className={classes["close-button"]}
            onClick={() => setOpen(false)}
          >
            متوجه شدم
          </button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default ContextHelp
